import {useLocation} from 'react-router-dom';
import {filterPreservedSearchParams} from './breadcrumbUtils';

function usePreservedSearchString(): string {
  const {search} = useLocation();
  return filterPreservedSearchParams(search);
}

export default usePreservedSearchString;
